import React from "react";
import { Tooltip, Button } from "@mui/material";

interface TooltipButtonProps {
    option: string;
    optionSelected: string;
    tooltip: string;
    onClick: (option: string) => void;
    children: React.ReactNode;
    disabled?: boolean;
}

const TooltipButton = (props: TooltipButtonProps) => {
    // console.log(`TooltipButton.render: option=${props.option}, optionSelected=${props.optionSelected}`);
    return <Tooltip title={props.tooltip}>
        <Button 
            onClick={() => props.onClick(props.option)}
            variant={props.optionSelected == props.option ? "contained" : "outlined"}
            disabled={props.disabled}
            // color={contentSelected === "survey-report" ? "primary" : "secondary"}
            >
            {props.children}
        </Button>
    </Tooltip>;
};

export default TooltipButton;
